import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { heroSlides } from '@/mocks/home';

export default function HeroSection() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const nextSlide = useCallback(() => {
    setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
  }, []);

  useEffect(() => {
    const timer = setInterval(nextSlide, 5000);
    return () => clearInterval(timer);
  }, [nextSlide]);

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20peach%20and%20coral%20toned%20abstract%20geometric%20background%20with%20soft%20flowing%20curves%20and%20gradients%2C%20modern%20minimalist%20design%2C%20clean%20and%20elegant%20aesthetic%2C%20film%20and%20media%20industry%20theme%2C%20warm%20lighting%20with%20golden%20accents%2C%20cinematic%20atmosphere&width=1600&height=900&seq=hero-bg-01&orientation=landscape"
          alt="蜜桃视频背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-black/55"></div>
      </div>

      <div className="relative z-10 w-full h-full flex items-center">
        <div className="max-w-7xl mx-auto px-4 md:px-6 w-full">
          <div className="max-w-2xl" key={currentSlide}>
            <h1 className="text-3xl md:text-5xl font-bold text-background-50 font-heading mb-4 animate-[fadeInUp_0.6s_ease-out]">
              {heroSlides[currentSlide].title}
            </h1>
            <p className="text-base md:text-lg text-background-200 mb-8 animate-[fadeInUp_0.6s_ease-out_0.1s]">
              {heroSlides[currentSlide].subtitle}
            </p>
            <div className="flex flex-col sm:flex-row gap-4 animate-[fadeInUp_0.6s_ease-out_0.2s]">
              <Link
                to={heroSlides[currentSlide].ctaLink}
                className="px-8 py-3 text-sm font-medium text-background-50 bg-primary-500 rounded-full hover:bg-primary-600 transition-all whitespace-nowrap text-center cursor-pointer"
              >
                {heroSlides[currentSlide].cta}
              </Link>
              <Link
                to="/about"
                className="px-8 py-3 text-sm font-medium text-background-50 border border-background-50/40 rounded-full hover:bg-background-50/10 transition-all whitespace-nowrap text-center cursor-pointer"
              >
                了解更多
              </Link>
            </div>
          </div>

          <div className="flex gap-2 mt-10">
            {heroSlides.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlide(index)}
                className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                  index === currentSlide
                    ? 'bg-primary-500 w-6'
                    : 'bg-background-50/40 hover:bg-background-50/60'
                }`}
                aria-label={`Slide ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>

      <style>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </section>
  );
}